import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { DocumentType } from 'src/app/shared/model/DocumentType';
import { UploadDocumentParameters } from 'src/app/feature-module/documents/models/UploadDocumentParameters';
import { debounceTime, map, switchMap, tap } from 'rxjs/operators';
import { ShowDocumentComponent } from 'src/app/feature-module/documents/component/show-document/show-document.component';
import { TranslateService } from '@ngx-translate/core';
import { DocumentService } from 'src/app/feature-module/documents/service/document.service';
import { ClaimDocumentationDocumentInfo } from 'src/app/feature-module/documents/models/ClaimDocumentationDocumentInfo';
import { DocumentInfo } from '../../models/DocumentInfo';
import { ExportDocumentsService } from '../../service/export-documents.service';
import { environment } from 'src/environments/environment';
import { SetClaimDocumentationDataComponent } from '../set-claim-documentation-data/set-claim-documentation-data.component';
import { UploadFilesSettings } from '../../models/UploadFilesSettings';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { ExportDocumentsData } from '../../models/ExportDocumentData';
import { CurrentClaimDataService } from 'src/app/feature-module/claims-data/service/current-claim-data.service';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { Abilities } from 'src/app/shared/model/Abilities';
import { ClaimDataService } from 'src/app/feature-module/claims-data/service/claim-data.service';
import { MediaService } from 'src/app/shared/services/media.service';

@Component({
  selector: 'app-claim-docs',
  templateUrl: './claim-docs.component.html',
  styleUrls: ['./claim-docs.component.scss']
})
export class ClaimDocsComponent implements OnInit {

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private documentService: DocumentService,
    private claimDataService: ClaimDataService,
    private customDialogService: CustomDialogService,
    private translateService: TranslateService,
    private exportDocumentsService: ExportDocumentsService,
    private uiNotification: UiNotificationService,
    private authService: AuthService,
    private mediaService: MediaService,
    private currentClaimDataService: CurrentClaimDataService) { }

  claimId: string;
  checkedAll = false;
  uploadDocumentParameters: UploadDocumentParameters;
  claimDocumentation: ClaimDocumentationDocumentInfo[];
  documentDataDialogContent = {content:SetClaimDocumentationDataComponent};
  
  uploadFilesSettings : UploadFilesSettings;
  isFileGenerating:boolean;
  hasCanRemoveSignedDocumentAbility = false;
  isLoading = false;
  isClaimArchived = false;
  @ViewChild("claimDocsDialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;

  ngOnInit() {
   
    this.hasCanRemoveSignedDocumentAbility = this.authService.hasAbility(Abilities.CanRemoveSignedDocument);

    this.claimId = this.activatedRoute.snapshot.paramMap.get('id');
   
      const uploadDocumentParameters: UploadDocumentParameters =
      {
        documentTypeId: DocumentType.ClaimDocumentation,
        referenceType: ReferenceType.Claim,
        referenceId: this.claimId,
        claimIdentifier: this.claimId,
        otherDocumentKindName : '',
        description: '',
        proofDocumentIds: [],
        validateProofDocumentsAutomatically: true
      }

      this.uploadFilesSettings = {
        uploadDocumentParameters  : uploadDocumentParameters,
        fileRestrictions  : null,
        showTopButtons : false,
        autoUpload : false,
        showDocumentDataDialog  : true,
        documentDataDialogContent : { content:SetClaimDocumentationDataComponent }

      };

      this.checkIsClaimArchived();
      this.getClaimDocumentation();


  }

  getClaimDocumentation(){
    this.isLoading = true;
     this.documentService.getClaimDocumentation( this.claimId ).pipe(debounceTime(1000),tap(() => (this.isLoading = false)))
    .subscribe({
      next: (r) => {
        this.claimDocumentation = r;
      }
    });
  }

  checkIsClaimArchived(){
    this.claimDataService.checkIsClaimArchive(this.claimId).subscribe({
      next: (r) => {
        this.isClaimArchived = r;
      },
    });
  }

  removeClaimDocumentation(documentInfoId: string){

    this.customDialogService.actionWithConfirmation('claims-center.claimDocumentation.doYouReallyWantToDeleteThisDocument',
    () => {
      this.documentService.removeClaimDocumentation(documentInfoId ).subscribe( ()=> this.getClaimDocumentation());
        },
        this.containerRef);
  }

  showContent(documentInfo:DocumentInfo){

    const dialogSettings: CustomDialogSettings = {
      content: ShowDocumentComponent,
      title: `${this.translateService.instant('claims-center.claimDocumentation.showContent')}  (${documentInfo.name})`,
      minHeight: '60vh',
       minWidth: '60vw',
       maxHeight: '80vh',
       maxWidth: '80vw',
      appendTo:this.containerRef,
      dialogInputs: {
        documentInfo: documentInfo
      }
    };

    this.customDialogService.showDialog(dialogSettings);

  }

  showContentInExternalWindow(documentId) {
    let webAppPath = '';
    if(environment.wepAppName){
      webAppPath = "/" + environment.wepAppName;
    }
    
   const documentLink = window.location.origin + webAppPath + '/documentCenter/documentContent/' + documentId;
    const width = this.mediaService.getFullHdRelativeWidth(0.75);
    const height = this.mediaService.getFullHdRelativeHeight(0.75);
    window.open(documentLink, "_documentContentViewer", 'width=' + width + ',height=' + height + ',toolbar=0,location=0,resizable=1,scrollbars=1'); return false;
  }

  toogleAllToExport() {
    this.checkedAll = !this.checkedAll;
    const ids = this.claimDocumentation.filter(x => !x.isArchived).map((x) => x.id);
    if (this.checkedAll) {
      this.exportDocumentsService.addDocuments(ids);
    } else {
      this.exportDocumentsService.removeDocuments(ids);
    }
  }

  attachCostEstimationDocs(){
    this.router.navigate(['/claimsCenter/view/' + this.claimId + '/handling/claimCostEstimations']);
  }

  downloadSingleFile(documentInfo: ClaimDocumentationDocumentInfo) {

    const task = this.uiNotification.showRunningOperation('operations.singleFilesExportOngoing');
    this.isFileGenerating = true;

    const ids = [documentInfo.id];
    this.documentService.getExportDocumentsData(ids).pipe(
      switchMap(
        (r: ExportDocumentsData) => {
          return this.documentService.downloadDocument(r.exportDocumentItems[0].id).pipe(
            map((content:Blob) => ({content: content, exportDocumentInfo:  r.exportDocumentItems[0]})
          ))
        })).subscribe({
          next: (res) => {
            const content = res.content;
            const exportDocumentInfo = res.exportDocumentInfo;
            const downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(new Blob([content], { type: 'application/octet-stream' }));
            downloadLink.setAttribute('download', exportDocumentInfo.nameForExport);
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.parentNode.removeChild(downloadLink);

            task.hide();
            this.isFileGenerating = false;
          }
          });
  }

  newUploadedItem(ev:any){

    this.getClaimDocumentation();
    this.currentClaimDataService.RefreshCurrentClaimSearchResultItem(this.claimId);
    this.currentClaimDataService.RefreshCurrentClaim(this.claimId);
  }
}



